/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useMemo, useState, useEffect } from 'react';

import { Typography, makeStyles, Grid } from '@material-ui/core';

import CreateCaseModel from '../../models/CreateCaseModel';
import EditFields from '../common/EditFields';

const useStyles = makeStyles((theme) => {
  return {
    fieldContainer: {
      paddingRight: '0px',
      [theme.breakpoints.up('md')]: {
        paddingRight: '16px',
      },
    },
    fieldDescription: {
      marginTop: '1rem',
    },
    fieldEditContainer: {
      marginBottom: '16px',
    },
    fieldSubtitle: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '18px',
      maxWidth: '528px',
    },
    fieldTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '21px',
      marginBottom: '0px',
    },
    iconPortal: {
      height: '30px',
      width: '30px',
    },
    onlinePortalContainer: {
      margin: '60px 0px 0px',
    },
  };
});

export default ({ onChangeFormOnlinePortalAccess, status }) => {
  const classes = useStyles();
  const [form, setForm] = useState(status);

  const portalAddressRef = useRef();
  const portalPasswordRef = useRef();
  const portalUsernameRef = useRef();
  const studyNameRef = useRef();

  const portalAddressField = useMemo(
    () => [
      {
        containerClass: classes.fieldEditContainer,
        label: 'Online Portal Web Address',
        name: 'portalAddress',
        onChange: (value, isValid) => {
          onChangeFormOnlinePortalAccess(value, 'portalAddress', isValid);
        },
        placeholder: 'Example: my_online_portal.com',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  const portalPasswordField = useMemo(
    () => [
      {
        containerClass: classes.fieldEditContainer,
        label: 'Portal Password',
        name: 'portalPassword',
        onChange: (value, isValid) => {
          onChangeFormOnlinePortalAccess(value, 'portalPassword', isValid);
        },
        placeholder: '',
        type: 'password',
        variant: 'standard',
      },
    ],
    []
  );

  const portalUsernameField = useMemo(
    () => [
      {
        containerClass: classes.fieldEditContainer,
        label: 'Portal Username',
        name: 'portalUsername',
        onChange: (value, isValid) => {
          onChangeFormOnlinePortalAccess(value, 'portalUsername', isValid);
        },
        placeholder: '',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  const studyNameField = useMemo(
    () => [
      {
        containerClass: classes.fieldEditContainer,
        label: 'Study description',
        name: 'studyName',
        onChange: (value, isValid) => {
          onChangeFormOnlinePortalAccess(value, 'studyName', isValid);
        },
        placeholder: 'Example: Head MRI, October 17, 2021',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  useEffect(() => {
    setForm(status);
  }, [status]);

  return (
    <Grid container>
      {/* The code field */}
      <Grid item xs={12} md={6} style={{ height: '100%', padding: '0 3rem' }}>
        <EditFields
          validate={CreateCaseModel.validateOnlinePortalAccess}
          data={form.formOnlinePortalAccess}
          labelClass={classes.labels}
          labelPosition="top"
          ref={portalAddressRef}
          fields={portalAddressField}
        />
      </Grid>

      <Grid item xs={12} md={6} style={{ height: '100%', padding: '0 3rem' }}>
        <EditFields
          validate={CreateCaseModel.validateOnlinePortalAccess}
          data={form.formOnlinePortalAccess}
          labelClass={classes.labels}
          labelPosition="top"
          ref={portalUsernameRef}
          fields={portalUsernameField}
        />
      </Grid>

      <Grid item xs={12} md={6} style={{ height: '100%', padding: '0 3rem' }}>
        <EditFields
          validate={CreateCaseModel.validateOnlinePortalAccess}
          data={form.formOnlinePortalAccess}
          labelClass={classes.labels}
          labelPosition="top"
          ref={portalPasswordRef}
          fields={portalPasswordField}
        />
        <Typography variant="body1" className={`body-copy ${classes.fieldDescription}`} align="left">
          We suggest changing your online portal password after we have produced your video report for you.{' '}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6} style={{ height: '100%', padding: '0 3rem' }}>
        <EditFields
          validate={CreateCaseModel.validateOnlinePortalAccess}
          data={form.formOnlinePortalAccess}
          labelClass={classes.labels}
          labelPosition="top"
          ref={studyNameRef}
          fields={studyNameField}
        />
      </Grid>
    </Grid>
  );
};
